import request from '../request'

export default {
  getCategoriasPersonal: function () {
    return request.get('personal_categoria')
  }
}
